<template>
  <div class="nx-searcher-filter-date pl-4 pr-4">

    <nx-date-picker
      name="date"
      autoclose
      :disabled="disabled"
      :label="$t('message.searcher.filters.values.date')"
      :value="value"
      clearable
      :minDate="minDate"
      :maxDate="maxDate"
      @input="dateSelected($event, 'from')"
    ></nx-date-picker>

  </div>
</template>

<script>
import moment from 'moment';
import Filter from './Filter';

export default {
  name: 'nx-searcher-filter-date',
  extends: Filter,
  components: {
    NxDatePicker: () => import('@/components/date/DatePicker'),
  },
  props: {
    // Initial value. If none is specified, the current date will be set.
    value: {
      type: String,
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
  },
  data() {
    return {
      format: 'YYYY/MM/DD',
    };
  },
  computed: {
  },
  methods: {
    dateSelected(date) {
      this.updateFilter(date ? moment(date).format(this.format) : null);
    },
  },
};
</script>

<style lang="stylus">
.nx-searcher-filter-date {

  margin-bottom: 12px;

  .v-input__slot {
    margin-bottom: 0
  }
  .v-messages {
    display: none;
  }
}
</style>
